import axios from "axios";
import { API_AUTH_URL } from "./config";


// Cliente exclusivo para endpoints de autenticación
const authApi = axios.create({
  baseURL: API_AUTH_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // 🔐 Muy importante para sesiones con cookies
});

// 🔹 Registro
export const registerMedico = async (formData) => {
  try {
    const response = await authApi.post("registration/", formData);
    return response.data;
  } catch (error) {
    console.error("Error en el registro:", error);
    throw error;
  }
};

// 🔹 Login
export const loginMedico = async (email, password) => {
  try {
    const response = await authApi.post("login/", {
      email,
      password,
    });

    localStorage.setItem("user_email", email); // Puedes guardar más si quieres
    return response.data;
  } catch (error) {
    console.error("Error en login:", error);
    throw error;
  }
};

// 🔹 Logout
export const logoutMedico = async () => {
  try {
    await authApi.post("logout/");
    localStorage.clear();
  } catch (error) {
    console.error("Error en logout:", error);
  }
};
function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";");
    for (let cookie of cookies) {
      const trimmed = cookie.trim();
      if (trimmed.startsWith(name + "=")) {
        cookieValue = decodeURIComponent(trimmed.split("=")[1]);
        break;
      }
    }
  }
  return cookieValue;
}

authApi.interceptors.request.use((config) => {
  const csrfToken = getCookie("csrftoken");
  if (csrfToken) {
    config.headers["X-CSRFToken"] = csrfToken;
  }
  return config;
});

export const fetchCsrfToken = async () => {
  try {
    await authApi.get("csrf/");
  } catch (error) {
    console.error("Error al obtener el CSRF token:", error);
  }
};

export const logout = async () => {
  try {
    // Asegúrate de obtener el CSRF antes del logout
    await fetchCsrfToken();

    const response = await authApi.post("logout/");

    localStorage.clear();
    return response.data;
  } catch (error) {
    console.error("❌ Error cerrando sesión:", error);
    throw error;
  }
};
export const cambiarPassword = async ({ old_password, new_password1, new_password2 }) => {
  try {
    const response = await authApi.post("password/change/", {
      old_password,
      new_password1,
      new_password2,
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error cambiando contraseña:", error.response?.data || error);
    throw error;
  }
};
export const solicitarResetPassword = async (email) => {
  try {
    const response = await authApi.post("password/reset/", { email });
    return response.data;
  } catch (error) {
    console.error("❌ Error solicitando reset:", error.response?.data || error);
    throw error;
  }
};
export const confirmarResetPassword = async ({ uid, token, new_password1, new_password2 }) => {
  try {
    const response = await authApi.post("password/reset/confirm/", {
      uid,
      token,
      new_password1,
      new_password2,
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error confirmando reset:", error.response?.data || error);
    throw error;
  }
};
